import { render, staticRenderFns } from "./StageResourceDistributionChart.vue?vue&type=template&id=860bd5d8&scoped=true"
import script from "./StageResourceDistributionChart.vue?vue&type=script&lang=js"
export * from "./StageResourceDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./StageResourceDistributionChart.vue?vue&type=style&index=0&id=860bd5d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860bd5d8",
  null
  
)

export default component.exports